import { Checkbox } from 'primereact/checkbox'
import { InputText } from 'primereact/inputtext'

import { Icon } from '../../../Components'
import { DraggableListServicePriority } from '../../../Components/Common/DraggableListServicePriority'
import { DraggableTrainFarePriority } from '../../../Components/Common/DraggableTrainFarePriority'
import { cap } from '../../../State'
import { translations } from '../../../translations'
import { DropdownElement } from './DropdownElement'
import { NewFilterDropdown } from './NewFilterDropdown'
const language = cap.language.state || 'IT'
const t = translations[language]

export const FilterElement = ({
  service: { icon, name, filters },
  selectedFilters: [selectedFilters, setSelectedFilters],
  inputValues: [inputValues, setInputValues],
  inputRimborso: [inputRimborso, setInputRimborso] = [],
  inputNoRimborso: [inputNoRimborso, setInputNoRimborso] = [],
  logicaCameraNonInPenale: [logicaCameraNonInPenale, setLogicaCameraNonInPenale] = [],
  soloCamereNonInPenale: [soloCamereNonInPenale, setSoloCamereNonInPenale] = [],
  tolleranzaGiorniPenale: [tolleranzaGiorniPenale, setTolleranzaGiorniPenale] = [],
  options: [options, setOptions],
  servicePriority: [servicePriority, setServicePriority] = [],
  flagAbilitazione: [flagAbilitazione, setFlagAbilitazione] = [],
  trainFarePriority: [trainFarePriority, setTrainFarePriority] = []
}) => {
  return (
    <div className="nsec">
      <div className="nsec__head">
        <div className="community-service-icon">
          <Icon name={icon} size={20} />
        </div>
        <div>
          <h3 className="nsec__title">
            {t.servizio} {t[name.toLowerCase()]}:
          </h3>
          <div
            style={{
              fontSize: 12,
              color: 'var(--ink-500)',
              fontWeight: 400,
              textTransform: 'none',
              letterSpacing: 0
            }}
          >
            {t.impostazionePreventiviGenerati}
          </div>
        </div>
      </div>
      <div className="nsec__body" style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
        {(selectedFilters || [])?.map((filter, index) => (
          <DropdownElement
            name={name}
            key={index}
            index={index}
            value={filter}
            options={options}
            selectedFilters={[selectedFilters, setSelectedFilters]}
            inputValues={[inputValues, setInputValues]}
            inputRimborso={[inputRimborso, setInputRimborso]}
            inputNoRimborso={[inputNoRimborso, setInputNoRimborso]}
            flagAbilitazione={[flagAbilitazione, setFlagAbilitazione]}
          />
        ))}
        <NewFilterDropdown
          name={name}
          options={options}
          selectedFilters={[selectedFilters, setSelectedFilters]}
          flagAbilitazione={[flagAbilitazione, setFlagAbilitazione]}
        />

        {name === 'Hotel' && (
          <div className="community-hotel-extra">
            <div style={{ display: 'flex', alignItems: 'flex-start', gap: 10 }}>
              <Checkbox
                checked={logicaCameraNonInPenale}
                onChange={(e) => setLogicaCameraNonInPenale(e.checked)}
              />
              <div>
                <div style={{ fontSize: 13, fontWeight: 600, color: 'var(--ink-900)' }}>
                  {t.logicaCameraNonInPenale}
                </div>
                <div style={{ fontSize: 11.5, color: 'var(--ink-500)' }}>
                  {t.logicaCameraNonInPenaleDescrizione1}
                </div>
                <div style={{ fontSize: 11.5, color: 'var(--ink-500)' }}>
                  {t.logicaCameraNonInPenaleDescrizione2}
                </div>
              </div>
            </div>
            {!!logicaCameraNonInPenale && (
              <div style={{ display: 'flex', alignItems: 'flex-start', gap: 10 }}>
                <Checkbox
                  onChange={(e) => setSoloCamereNonInPenale(e.checked)}
                  checked={soloCamereNonInPenale}
                />
                <div>
                  <div style={{ fontSize: 13, fontWeight: 600, color: 'var(--ink-900)' }}>
                    {t.soloCamereNonInPenale}
                  </div>
                  <div style={{ fontSize: 11.5, color: 'var(--ink-500)' }}>
                    {t.soloCamereNonInPenaleDescrizione}
                  </div>
                </div>
              </div>
            )}
            <div className="nfield" style={{ maxWidth: 220, marginTop: 4 }}>
              <label>{t.tolleranzaGiorniPenale}</label>
              <InputText
                value={tolleranzaGiorniPenale}
                onChange={({ target: { value } }) => setTolleranzaGiorniPenale(value)}
                style={{ borderRadius: 8, width: '100%' }}
              />
            </div>
          </div>
        )}

        {name === 'Treno' && (
          <div className="community-train-extra">
            <div
              style={{
                fontSize: 12,
                fontWeight: 600,
                color: 'var(--ink-700)',
                textTransform: 'uppercase',
                letterSpacing: '0.04em'
              }}
            >
              {t.selezionaPrioritaServizio}
            </div>
            <DraggableListServicePriority data={servicePriority} onUpdate={setServicePriority} />
            <DraggableTrainFarePriority
              data={trainFarePriority?.rimborsabile || []}
              onUpdate={(data) =>
                setTrainFarePriority({ ...trainFarePriority, rimborsabile: data })
              }
              fareCategory="rimborsabile"
            />
            <DraggableTrainFarePriority
              data={trainFarePriority?.nonRimborsabile || []}
              onUpdate={(data) =>
                setTrainFarePriority({ ...trainFarePriority, nonRimborsabile: data })
              }
              fareCategory="nonRimborsabile"
            />
          </div>
        )}
      </div>
    </div>
  )
}
